module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "LavenderIconHover.69f89953.svg";